<template>
  <div class="box1-container">
    <div class="title" @click="scrollToBottom()">网关一日志</div>
    <div class="content">
      <el-scrollbar class="scroll_box" ref="scrollDataRef">
        <template v-if="resData.length">
          <div class="message_one" v-for="(item, index) in resData" :key="index">
            <!--  连接断开  -->
            <p v-if="item.type == -4" class="red">
              <em class="block_bg red_bg">应用</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>
            <p v-else-if="item.type == -3" class="red">
              <em class="block_bg red_bg">策略</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>
            <p v-else-if="item.type == -2" class="red">
              <em class="block_bg red_bg">人脸识别</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>
            <p v-else-if="item.type == -1" class="red">
              <em class="block_bg red_bg">连接</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

            <p v-else-if="item.type == 0" class="blue">
              <em class="block_bg blue_bg">心跳</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

            <p v-else-if="item.type == 1" class="green">
              <em class="block_bg green_bg">通讯</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>
            <p v-else-if="item.type == 2" class="blue">
              <em class="block_bg blue_bg">网关</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

            <p v-else-if="item.type == 3" class="white">
              <em class="block_bg white_bg">人脸识别</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

            <p v-else-if="item.type == 4" class="green">
              <em class="block_bg green_bg">策略</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

            <p v-else-if="item.type == 5" class="green">
              <em class="block_bg green_bg">应用</em>
              {{item.desc}}
              <span class="grap">{{item.created_at}}</span>
            </p>

          </div>
        </template>
        <div v-else>
          <p class="red"><em class="block_bg red_bg">ERROR</em>网关1 离线状态</p>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import homeApi from "@/api/home/index";
export default {
  name: "Box1",
  data() {
    return {
      resData: [],
      timer2: null
    }
  },
  methods: {
    getData() {
      homeApi.getHistory(0).then((res) => {
        if(res){
          if (res.data.code === 1000) {
            let resD =res.data.data
            if(resD.length){
              this.resData = this.resData.concat(resD);
              setTimeout(() => {
                this.scrollToBottom()
              },200)
            } 
          }
        }else{
          this.$message.error('接口错误!');
        }
        
      });
    },
    scrollToBottom() {
      this.$refs.scrollDataRef.wrap.scrollTop = this.$refs.scrollDataRef.wrap.scrollHeight
    }
  },
  mounted() {
    this.getData();
    if (this.timer2) {
      clearInterval(this.timer2);
    } else {
      this.timer2 = setInterval(() => {
        setTimeout(this.getData(), 0);
      }, 1 * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer2)
    this.timer2 = null
  }
};
</script>
<style lang='less'>
.box1-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #06113c;
  padding:15px 5px 5px 5px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    line-height: 35px;
    font-weight: normal;
    color: #fff;
    display: block;
    width: 100%;
    height:35px;
    text-align: center;
    background: url(../../assets/images/title_bg.png) center top no-repeat;
    background-size: auto 100%;
  }
  .content {
    position: absolute;
    top: 60px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding:10px;
    background: #030b28;
    .scroll_box{
      width:100%;
      height:100%;
      font-size:12px;
      color:#fff;
      line-height: 1.8;
      font-family: Arial,sans-serif;
      .message_one{
        margin:15px 0 0;
      }
      p{
        margin:0;
        font-family: Arial,sans-serif;
      }
      em,span,h1{
        font-style: normal;
        font-family: Arial,sans-serif;
      }
      
      span{
        margin-left:10px;
        font-family: Arial,sans-serif;
      }
      .block_bg{
        background: #0dbc79;
        display: inline-block;
        padding:3px 5px;
        line-height: 1.1;
        color:#000;
        margin-right: 5px;
        font-family: Arial,sans-serif;
      }
      .white{
        color:#fff
      }
      .white_bg{
        background:#fff
      }
      .green{
        color:#0dbc79
      }
      .green_bg{
        background:#0dbc79
      }
      .red{
        color:#cd3131
      }
      .red_bg{
        background:#cd3131
      }
      .blue{
        color:#2472c8
      }
      .blue_bg{
        background:#2472c8
      }
      .grap{
        color:#919191
      }
    }
  }
}


.el-scrollbar__wrap{
  overflow-x: hidden !important;
}
.is-horizontal{
  display: none;
}
// /deep/ .el-scrollbar__wrap {
// overflow-x: hidden;
// }
</style>
